import axios from 'axios'
import {getPatientSnapshot,savePatientSnapshot} from '../util/indexedDb'
import {randomPatientId} from '../util/toolFuncs'
import {createInsuranceRecord} from './insuranceQuery'

//eslint-disable-next-line
async function sleep(t) {
    return new Promise(resolve=>setTimeout(resolve, t*1000));
}

export const forgetPassword = async (email)=>{
    return (await axios.get(`/user/forgetpassword/${email}`)).data
}

export const resetPassword = async ({password,disableMFA,token}) => {
    return (await axios.post(`/user/resetpassword`,{password,disableMFA},
    {headers: {Authorization: token}})).data
}

export const loadFamilyMembers = async () =>{    
    const res = await axios.get('/user/getFamilyMembers')
    return res.data
}


export const getSubOrgnizationUser = async (orgId) => {
    const res = await axios.get(`/user/getSubOrganizationUser/?orgId=${orgId}`)
    return res.data
}

export const deleteUser = async (userId) => {
    return (await axios.delete(`/user/${userId}`)).data    
}

export const createCorpClientUser = async (user) => {
    return (await axios.post('/user/createCorpClientUser', user)).data    
}


export const getPatientRecordSnapshot = async (orgId) => {    
    let lastUpdateAt = ''
    let localData = {lastUpdateAt,snapshots:{},orgId}
    try {
        const local = await getPatientSnapshot(orgId)
        if (local) {
            localData = local
        }        
        lastUpdateAt = localData.lastUpdateAt || ''
    } catch (error) {
        // console.log('load local snapshot error' , error)
    }
        
    const serverData = (await axios.get(`/patient/patientRecordSnapshot/${orgId}?lastUpdateAt=${lastUpdateAt}`)).data
    serverData.forEach(item => {
        if (item.lastUpdateAt>localData.lastUpdateAt) {
            localData.lastUpdateAt = item.lastUpdateAt
        }
        localData.snapshots[item.id] = item
    })
    try {
        await savePatientSnapshot(localData)
    } catch (error) {
        // console.log('save local snapshot error' , error)
    }
    const result = []
    const ids = []
    for (let key in localData.snapshots) {
        const doc = localData.snapshots[key]
        const names = doc.names
        const patientDocIds = doc.patientDocIds
        const patientIds = doc.patientIds
        names.forEach((name,idx) => {
            // if the patient docId is already added, don't add it again
            // this could happen when the user is loading from multiple orgIds.
            // we have to use patientDocId because the patient Id might not be uniq.
            if (ids.includes(patientDocIds[idx])){
                return
            }
            ids.push(patientDocIds[idx])
            result.push({
                id: patientDocIds[idx],
                label: `${patientIds[idx]} : ${name}`,
                patientId: patientIds[idx]
            })
        })
    }
    return result

}

export const getPatientRecord = async (docId) => {
    return (await axios.get(`/patient/patientRecord/${docId}`)).data
}


export const getPatientRecordNoAuth = async (docId) => {
    return (await axios.get(`/patient/patientRecordNoAuth/${docId}`)).data
}


// this function use the gorup patient signup endpoint. and it doens't requrie authentication.
export const getGroupPatientRecord = async (docId) => {
    // await sleep(3)
    return (await axios.post(`/data/getGroupPatientInfoV2`,{docId})).data
}


export const sendConsentReminder = async ({docId,orgId}) =>{
    return (await axios.post('/booking/sendConsentReminder',{docId,orgId})).data
}

export const createFamilyAccount = async ({name,email,password,orgId,confNo}) =>{    
    return (await axios.post('/user/createFamilyAccount',{name,email,password,orgId,confNo})).data
}

export const verifyEmail = async ({token})=>{        
    return (await axios.post('/user/emailCallback',{token}, {headers:{Authorization:token}} )).data
}

export const sendEmailVerification = async ({email})=>{    
    return (await axios.post('/user/sendEmailVerification',{email} )).data
}


export const createPatientRecord = async (patient) => {
    return (await axios.post('/patient/patientRecord',patient)).data
}

export const updatePatientRecord = async ({id,...patient}) => {
    return (await axios.put(`/patient/patientRecord/${id}`,patient)).data
}


export const deletePatientRecord = async (patientId)=>{    
    return (await axios.delete(`/patient/patientRecord/${patientId}`)).data
}

const processFamilyPatientData = async (data)=>{
    let newInsuranceFormId = ""
    if (data.insuranceFormId ==='create-new' ) {
        const formData = new FormData()
        if (data.insured==='true'){
            ['insured','insuranceCompany','subscriberID','bFirstName',
            'bLastName','bDob','bGender','bMaritalStatus','bAddress',
            'bPatient_city','bPatient_state','bZip'].forEach(key=>{
                formData.append(key,data[key])
            })
            data.files.forEach(({file})=>{
                formData.append('file',file)
            })                  
        } else {
            ['insured','firstName','lastName','dob','gender','patient_city','patient_state','address','zip'].forEach(key=>{
                formData.append(key,data[key])
            })
        }
        if (data.groupOwner.length>0) {
            formData.append('groupOwner',data.groupOwner.join(','))
        }        
        const result = await createInsuranceRecord(formData)
        data.insuranceFormId = result.id
        
        if (data.insured==='true') {
            newInsuranceFormId = result.id
        }
    } else if (data.insuranceFormId ==='decline-insurance') {
        data.insuranceFormId = ""
    }
    data.hasInsuranceInfo = !! data.insuranceFormId
    const patientData = {consent:true,terms:true};
    ['firstName','lastName','dob','gender','patient_city','patient_state','race',
    'patient_ethnicity','address','zip','groupOwner','userOwner','hasInsuranceInfo',
    'insuranceFormId','patientType','relationship',
    'email','patient_phone','patientId',
    ].forEach(key=>{
        if (data[key] !== undefined) {
            patientData[key] = data[key]
        }
    })    
    return {patientData,newInsuranceFormId}
}


export const createFamilyPatient = async (data)=>{    
    const {patientData,newInsuranceFormId} = await processFamilyPatientData(data)
    // the patient is already consent in this case.    
    // attach a random patient Id
    if (!patientData.patientId) {
        patientData.patientId = randomPatientId()
    }    
    const patient = await createPatientRecord(patientData)
    return {patient, newInsuranceFormId}
}

export const updateFamilyPatient = async (data)=>{
    const {patientData,newInsuranceFormId} = await processFamilyPatientData(data)
    // the patient is already consent in this case.
    await updatePatientRecord({...patientData, id:data.id})
    patientData.id = data.id
    return {patient:patientData,newInsuranceFormId}
}

export const updateUserData = async (data)=>{    
    return (await axios.put('/user/updateUser',data)).data
}

export const uploadUserAvatar = async ({col,docId,formData})=>{
    return (await axios.post(`/user/uploadAvatar/${col}/${docId}`,formData)).data
}

/**
 * Update a user from provided email or confNo.
 * New patient records are searched.
 */
export const addFamilyMemberByEmailOrConfNo = async ({email,confNo})=>{    
    return (await axios.post('/user/addFamilyMemberByEmailOrConfNo',{email,confNo})).data
}


export const recoverUserAccount = async ({email,userId,password})=>{
    return (await axios.post('/user/recoverUserAccount',{email,userId,password})).data
}


export const getRecoverUserAccount = async ({recoveryCode,email})=>{
    return (await axios.get(`/user/recoverUserAccount/?code=${recoveryCode}&email=${email}`)).data
}

export const validatePatientRecords = async ({records}) => {
    return (await axios.post('/patient/validatePatientRecords',{records})).data
}

export const bulkUpsertPatientRecords = async (toUpdate) => {
    return (await axios.post('/patient/bulkUpsertPatientRecords',toUpdate)).data
}

export const bulkDeletePatientRecords = async ({docIds,user}) => {    
    return (await axios.post('/patient/bulkDeletePatientRecords',{docIds,user})).data
}

export const queryPatientRecords = async ({query,limit, lastDocId }) => {
    return (await axios.post('/patient/queryPatientRecords',{query,limit, lastDocId })).data
}

/**
 * 
 * @param {{patientDocIds:[string],password:string|null,email:string|null,notes:{en:string,es:string}}} payload
 * @returns 
 */
export const bulkSendConsentReminderTask = async (payload) => {
    return (await axios.post('/patient/bulkSendConsentReminderTask',payload)).data
}

/**
 * This method was duplicated from bulkSendConsentReminderTask (above)
 * @param {{patientDocIds:[string],password:string|null,email:string|null,notes:{en:string,es:string}}} payload
 * @returns 
 */
export const bulkSendOptInOutEmailTask = async (payload) => {
    return (await axios.post('/patient/bulkSendOptInOutEmailTask', payload)).data;
}